import { put, takeEvery, all } from "redux-saga/effects"

import {
  RECEIVE_CREATE,
  RECEIVE_UPDATE,
  RECEIVE_DELETE,
  RECEIVE_IMPORT
} from "containers/AddressModal/constants"

export default function saga(props) {
  const { actions } = props

  const handleReceive = function*() {
    yield put(actions.applyFilter({ reset: true }))
  }

  return function* root() {
    yield all([
      takeEvery(RECEIVE_CREATE, handleReceive),
      takeEvery(RECEIVE_UPDATE, handleReceive),
      takeEvery(RECEIVE_DELETE, handleReceive),
      takeEvery(RECEIVE_IMPORT, handleReceive)
    ])
  }
}
